import { Route, Routes } from "react-router-dom";
import VendorQuotationExcelCreateScreen from "screens/App/CRM/VendorQuotationExcel/VendorQuotationExcelCreateScreen";
import VendorQuotationExcelDetailScreen from "screens/App/CRM/VendorQuotationExcel/VendorQuotationExcelDetailScreen";
import VendorQuotationExcelEditDispatcher from "screens/App/CRM/VendorQuotationExcel/VendorQuotationExcelEditDispatcher";
import VendorQuotationExcelImportCreateScreen from "screens/App/CRM/VendorQuotationExcel/VendorQuotationExcelImportCreateScreen";
import VendorQuotationExcelListScreen from "screens/App/CRM/VendorQuotationExcel/VendorQuotationExcelListScreen";


import { NotFoundScreen } from "screens/NotFoundScreen";

const VendorQuotationExcelRouter = () => {
  return (
    <Routes>
      <Route path="/create" element={<VendorQuotationExcelCreateScreen />} />
      <Route path="/create-import" element={<VendorQuotationExcelImportCreateScreen />} />
      <Route path="/:id/detail" element={<VendorQuotationExcelDetailScreen />} />
      <Route path=":id/edit" element={<VendorQuotationExcelEditDispatcher  />} />
      <Route path="/list" element={<VendorQuotationExcelListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VendorQuotationExcelRouter;
